export enum BusinessFieldViewType {
  SINGLE = 'SINGLE',
  MULTIPLE = 'MULTIPLE',
  TABLE = 'TABLE',
  FIELDS = 'FIELDS'
}
